import React from 'react';
import Loadable from 'react-loadable';
import otRoutes from './Modules/ot';
import customerRoutes from './Modules/customer';
import userRoutes from './Modules/user';
import entityRoutes from './Modules/entity';
import productRoutes from './Modules/product';
import reportRoutes from './Modules/reports';
import unitRoutes from './Modules/unit';

const Dashboard = Loadable({
    loader: () => import('../Containers/Dashboard/HomeContainer'),
    loading: () => {
        return (<h3>Cargando...</h3>);
    }
});

const Help = Loadable({
    loader: () => import('../Containers/Help/HelpContainer'),
    loading: () => {
        return (<h3>Cargando...</h3>);
    }
});

const Home = Loadable({
    loader: () => import('../Components/Dashboard/AdminDashboard'),
    loading: () => {
        return (<h3>Cargando...</h3>);
    }
});

const routes = [
    ...otRoutes,
    ...customerRoutes,
    ...userRoutes,
    ...entityRoutes,
    ...productRoutes,
    ...reportRoutes,
    ...unitRoutes,
    ...[
        { path: '/home', name: 'Home', exact: true, component: Home },
        { path: '/help', name: 'Ayuda', exact: true, component: Help },
        { path: '/dashboard', name: 'Administración', exact: true, component: Dashboard },
    ],
];

const menu = {
    items: [
        {
            name: 'Crear',
            icon: 'icon-settings',
            children: [
                {
                    name: '- OT',
                    url: '/ot/quick-create',
                    icon: 'icon-list',
                },
                {
                    name: '- Cotización',
                    url: '/quote/quick-create',
                    icon: 'icon-briefcase',
                },
                {
                    name: '- Cliente',
                    url: '/customer/create',
                    icon: 'icon-people',
                },
                {
                    name: '- Producto',
                    url: '/product/create',
                    icon: 'icon-layers',
                },
            ]
        },
        {
            name: 'Home',
            url: '/home',
            icon: 'icon-grid',
        },
        {
            name: 'Dashboard',
            url: '/dashboard',
            icon: 'icon-chart',
        },
        {
            name: 'Calendario',
            url: '/ot/calendar',
            icon: 'icon-calendar',
        },
        {
            name: 'Ordenes',
            url: '/ot/list',
            icon: 'icon-list',
        },
        {
            name: 'Cotizaciones',
            url: '/quote/list',
            icon: 'icon-briefcase',
        },
        {
            name: 'Clientes',
            url: '/customer/list',
            icon: 'icon-people',
        },
        {
            name: 'Productos',
            url: '/product/list',
            icon: 'icon-layers',
        },
        {
            name: 'Configuración',
            icon: 'icon-settings',
            children: [
                {
                    name: 'Mi Empresa',
                    url: '/entity',
                    icon: 'icon-organization',
                },
                {
                    name: 'Usuarios',
                    url: '/user/list',
                    icon: 'icon-people',
                },
                {
                    name: 'Unidades',
                    url: '/unit/list',
                    icon: 'icon-people',
                },
            ]
        },
        {
            name: 'Reportes',
            icon: 'icon-calculator',
            children: [
                {
                    name: 'Ventas',
                    url: '/report/sales',
                    icon: 'icon-exclamation',
                },
                {
                    name: 'Utilidades',
                    url: '/report/profits',
                    icon: 'icon-star',
                },
            ]
        },
        {
            name: 'Ayuda',
            url: '/help',
            icon: 'icon-question',
        }
    ],
};

export default {
    menu,
    routes,
};


// WEBPACK FOOTER //
// ./src/Routes/admin.js